var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 mb-2"},[(_vm.label)?_c('label',[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]):_vm._e(),_vm._v(" "),_c('div',{ref:"treeContainer"},[_c('hr')])])
}
var staticRenderFns = []

export { render, staticRenderFns }